import React, { Component } from 'react';
import { withStyles } from '@mui/styles';
import {
  Tabs as MaterialTabs,
  Tab,
} from '@mui/material';

const styles = theme => ({
  tabStyle: {
    minWidth: 100,
    textTransform: 'capitalize !important',
    '&.Mui-selected': {
      background: theme.palette.common.white,
    },
    minHeight: 40,
    height: 40,
    fontSize: 14,
  },
  indicator: {
    display: 'none',
  },
  tabContainer: {
    backgroundColor: theme.palette.light.lightgrey,
    border: `1px solid ${theme.palette.light.darkgrey}`,
    minHeight: 40,
    height: 40,
  },
});

class Tabs extends Component {
  handleChange = (_event, newValue) => {
    this.props.onChange(newValue);
  };

  render() {
    const {
      classes,
      value,
      tabNames,
    } = this.props;

    return (
      <MaterialTabs value={value} onChange={this.handleChange} classes={{ indicator: classes.indicator }} className={classes.tabContainer}>
        {tabNames.map(name => <Tab label={name} className={classes.tabStyle} key={name} />)}
      </MaterialTabs>
    );
  }
}

export default withStyles(styles)(Tabs);
